import { useMutation } from 'react-query';
import { TemplateType } from 'types/narrative/narrative.types';

import { updateTemplateText as mutationFn } from 'api/endPoints/updateTemplateText';

export const useMutationUpdateTemplateText = () => {
    return useMutation<string, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

export interface QueryParams {
    componentKey: string;
    componentId: number;
    text: string;
    aiText: string;
    forCurrentCustomerOnly: boolean;
    templateType: TemplateType;
}
